import { request, type RuoYiPage } from '@/utils/request';

export interface NewsItem {
  newsId: number;
  newsTitle: string;
  newsContent: string;
  newsKeywords: string;
  newsCover: string;
  createTime?: string;
}

export function getNewsList(params?: { pageNum?: number; pageSize?: number; newsTitle?: string; newsKeywords?: string }) {
  return request<RuoYiPage<NewsItem>>('/system/news/list', params);
}

export function getNews(newsId: number | string) {
  return request<{ code: number; msg: string; data: NewsItem }>(`/system/news/${newsId}`);
}

